import axios from 'axios';
import config from '../environment/config';
import { authHeader } from './auth.header';
const API_URL = config.API_URL;



export const login = async (username, password) => {
  try {
    const response = await axios.post(`${API_URL}authenticate`, {
      username: username.trim(), // Remove extra spaces
      password: password.trim()
    });
    return response.data;
  } catch (error) {
    console.error('Error occurred in login:', error);
    throw error;
  }
};



export const customAuditStampingLogin = async (username) => { 
  if (!username) {
    throw new Error('No user found');
  }

  try {
    const response = await axios.post(
      `${API_URL}custom-audit-stamping-login`,
      username,  
      { headers: { 'Content-Type': 'application/json', ...authHeader() } }
    );
    return response.data;
  } catch (error) {
    console.error('Error occurred in customAuditStampingLogin:', error);
    throw error;
  }
};



export const logout = async (logoutType) => {
      try {
        const user = JSON.parse(localStorage.getItem('user')); 
      customAuditStampingLogout(user?.username,logoutType);
        localStorage.removeItem('user');
        localStorage.clear();

      } catch (error) {
        console.error('Error occurred in logout:', error);
        throw error; 
      }
  };



  export const customAuditStampingLogout = async (username, logoutType) => {
    if (!username) {
      throw new Error('No user found');
    }
  
    try {
      const response = await axios.put(
        `${API_URL}custom-audit-stamping-logout`,
       {},
        { 
          params: {logoutType},
          headers: authHeader() }
      );
      return response.data;
    } catch (error) {
      console.error('Error occurred in customAuditStampingLogout:', error);
      throw error;
    }
  };
  

